export default __webpack_public_path__ + "static/media/servicio_practicas_voluntariado.9e765322.pdf";